import { createStore, applyMiddleware, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga'
import Thunk from 'redux-thunk'

import modalReducer from '@krea/common/store/modal/reducer'
import generalReducer from '@krea/common/store/general/reducer'
import userReducer from '@krea/common/store/user/reducer'
import fieldRequestsReducer from '@krea/common/store/field-requests/reducer'
import loanApplicationFormReducer from '@krea/common/store/loan-application-form/FormReducer'

import { logoutSaga } from '@krea/common/store/user/sagas'
import { fetchImportantInformationTypesSaga, fetchReferrerDataSaga } from '@krea/common/store/general/sagas'
import {
	fetchFieldRequestsDataSaga,
	fetchFieldRequestDataSaga,
	postFieldRequestDataSaga,
	putAccountingIntegrationDataSaga,
	deleteFileSaga,
	delegateFieldRequestSaga,
	withdrawDelegationForFieldRequestSaga,
	fetchDelegatedFieldRequestsDataSaga,
	minimizeOnSuccess
} from '@krea/common/store/field-requests/sagas'

import bankidReducer from 'store/bankId/reducer'
import lenderResponsesReducer from 'store/lender-responses/reducer'
import loanApplicationsReducer from 'store/loan-applications/reducer'
import trackingReducer from 'store/loan-application-form/TrackingReducer'
import currentLoanApplicationReducer from 'store/current-loan-application/reducer'

import { fetchUserDataSaga } from 'store/user/sagas'
import { trackFormSaga } from './store/loan-application-form/trackingSaga'
import { fetchLoanApplicationsDataSaga } from 'store/loan-applications/sagas'
import { mergeQueryParamsSaga } from 'store/loan-application-form/queryParamsSaga'
import { fetchLenderResponsesDataSaga, selectLenderResponseSaga } from 'store/lender-responses/sagas'
import { initiateSendingFormSaga, postFormSaga, persistFormSaga } from 'store/loan-application-form/formSaga'

import {
	bankIdAuthenticateSaga,
	bankIDInitiationCallback,
	bankIdCollectSaga,
	bankIdCancelSaga
} from 'store/bankId/sagas'

import {
	fetchCurrentLoanApplicationDataSaga,
	selectCurrentLoanApplicationSaga,
	fetchSelectedLenderResponseDataSaga,
	submitApplicationSaga,
	adviceSaga,
	withoutAdviceSaga
} from 'store/current-loan-application/sagas'

import {
	sendApplicationDraftTrackingSaga,
	sendApplicationDraftWithFactoringTrackingSaga,
	sendApplicationDraftWithRealEstateTrackingSaga,
	sendApplicationCreatedTrackingSaga,
	sendApplicationCreatedWithFactoringTrackingSaga,
	sendReceivedLoanBidTrackingSaga,
	sendReceivedFactoringBidTrackingSaga,
	sendSelectLenderResponseTrackingSaga,
	sendSelectLenderResponseWithFactoringTrackingSaga,
	sendApplicationCreatedWithRealEstateTrackingSaga,
	sendReceivedRealEstateBidTrackingSaga,
	sendSelectLenderResponseWithRealEstateTrackingSaga
} from 'store/tracking/sagas'

import runner from './runner'

function RootSaga() {
	return function* rootSaga(additionalSagas = []) {
		yield runner([
			fetchImportantInformationTypesSaga,
			fetchUserDataSaga,
			logoutSaga,
			fetchLoanApplicationsDataSaga,
			fetchFieldRequestsDataSaga,
			fetchFieldRequestDataSaga,
			fetchLenderResponsesDataSaga,
			fetchCurrentLoanApplicationDataSaga,
			fetchSelectedLenderResponseDataSaga,
			selectCurrentLoanApplicationSaga,
			selectLenderResponseSaga,
			fetchReferrerDataSaga,
			postFieldRequestDataSaga,
			putAccountingIntegrationDataSaga,
			deleteFileSaga,
			fetchDelegatedFieldRequestsDataSaga,
			delegateFieldRequestSaga,
			withdrawDelegationForFieldRequestSaga,
			minimizeOnSuccess,
			submitApplicationSaga,
			adviceSaga,
			withoutAdviceSaga,
			sendApplicationDraftTrackingSaga,
			sendApplicationDraftWithFactoringTrackingSaga,
			sendApplicationDraftWithRealEstateTrackingSaga,
			sendApplicationCreatedTrackingSaga,
			sendApplicationCreatedWithFactoringTrackingSaga,
			sendApplicationCreatedWithRealEstateTrackingSaga,
			sendReceivedLoanBidTrackingSaga,
			sendReceivedFactoringBidTrackingSaga,
			sendReceivedRealEstateBidTrackingSaga,
			sendSelectLenderResponseTrackingSaga,
			sendSelectLenderResponseWithFactoringTrackingSaga,
			sendSelectLenderResponseWithRealEstateTrackingSaga,
			bankIdAuthenticateSaga,
			bankIDInitiationCallback,
			bankIdCollectSaga,
			bankIdCancelSaga,
			initiateSendingFormSaga,
			postFormSaga,
			persistFormSaga,
			trackFormSaga,
			mergeQueryParamsSaga,
			...additionalSagas
		])
	}
}

export default function LenderFrontendStore({
	additionalReducers = {},
	additionalSagas = [],
	additionalMiddleware = []
} = {}) {
	const sagaMiddleware = createSagaMiddleware()

	const store = createStore(
		combineReducers({
			...additionalReducers,
			generalReducer,
			userReducer,
			loanApplicationsReducer,
			fieldRequestsReducer,
			lenderResponsesReducer,
			currentLoanApplicationReducer,
			modalReducer,
			bankidReducer,
			loanApplicationFormReducer,
			trackingReducer
		}),
		applyMiddleware(Thunk, sagaMiddleware, ...additionalMiddleware)
	)

	sagaMiddleware.run(RootSaga(additionalSagas))
	window.ReduxStore = store
	return store
}
